<section id="content-wrapper" class="">
	<div class="wrap">



		<div class="content-container my-order">
			<section class="data-table">

				<header class="data-table__header">
					<h2 class="page-heading tab-content-header active" id="products-content-header">
						<ng-container i18n="@@my_catalogue_details">My Catalogue Details</ng-container>
					</h2>
				</header>

				<div class="data-table__wrap">
					<div class="header_options flex-none-column align-items-none-start gap-none-4">
						<div class="header_option">
							<ng-container i18n="@@receive_orders">Receive orders</ng-container>
							<div class="switch-wrapper">
								<div class="switch">
									<input class="product-switch" type="checkbox" id="auto-renew" name="auto-renew" [(ngModel)]="shopStatus">
									<span class="slider round"></span>
								</div>
							</div>
						</div>
						<div class="header_option">
							<ng-container i18n="@@auto_accept_order">Auto accept order</ng-container>
							<div class="switch-wrapper">
								<div class="switch">
									<input class="product-switch" type="checkbox" id="auto-renew" name="auto-renew" [(ngModel)]="autoAccept">
									<span class="slider round"></span>
								</div>
							</div>
						</div>
					</div>

					<header class="data-table__controls">
						<div class="select-date-from select-pages">
							<div class="select-pages_tabs">
								<ul class="tabs_content">
									<li class="tab_item" [class.active]="activeTab == 'general'" data-target="general" (click)="tabChange('general')">
										<ng-container i18n="@@store.general">General</ng-container>
									</li>
									<li class="tab_item" [class.active]="activeTab == 'store-address'" data-target="store-address" (click)="tabChange('store-address')">
										<ng-container i18n="@@store.store_address">Store address</ng-container>
									</li>
								</ul>
							</div>
						</div>
					</header>

					<div class="tab-content">
						<div class="tab-content data-table__tab-content" id="pills-tabContent">
							<form [formGroup]="storeInformationForm" (ngSubmit)="onSubmit()" id="ngForm" #informationForm="ngForm">
							<div class="tab-pane fade" [class.show]="activeTab == 'general'" [class.active]="activeTab == 'general'" id="general-content" role="tabpanel" aria-labelledby="pills-all-order-tab">
								<div id="my-store_info" style="width: 100%">



									<div class="catalogue-details__uploader">
										<div class="catalogue-details__uploaderTexts">
											<p i18n="@@upload_catalogue_cover_photo">Upload catalogue cover photo</p>
											<span i18n="@@png_jpg_files_are_allowed">PNG, JPG files are allowed</span>
										</div>
										<fieldset class="logo-uploder">
											<file-pond #logoFile
                        [options]="pondOptions"
                        [files]="coverImageUrl"
                        (oninit)="pondHandleInit()"
                        (onaddfile)="pondHandleAddFile($event)"
                        (onprocessfileabort)="pondHandleRemoveFile($event)"
                      >
											</file-pond>
										</fieldset>
										<div class="catalogue-details__uploaderUploadText">
											<span i18n="@@drag_drop_file">Drag and drop or browse to choose a file</span>
										</div>
									</div>


									<div class="user_info_container">
										<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
											<div class="w-50 w-none-100">
												<fieldset [ngClass]="{ 'has-error': (isSubmitted || f.name.dirty) && f.name?.errors }">
													<label i18n="@@business.business_name">Business Name</label><span class="required-star">*</span>
													<input type="text" name="store-name" formControlName="name" (keyup)="convertToSlug($event.target.value)" (blur)="convertToSlug($event.target.value)" />
													<span class="field-error" i18n="@@error.required.store_name" *ngIf="(isSubmitted || f.name.dirty) && f.name.errors?.required">Store name is required</span>
													<span class="field-error" *ngIf="f.name.errors?.serverError">{{ f.name.errors?.serverError }}</span>
												</fieldset>
											</div>

											<div class="w-50 w-none-100">
												<label i18n="@@business_type">Business Type</label>
												<div class="radio-group d-flex justify-content-start align-items-center gap-5 flex-none-column align-items-none-start" id="business-type">
													<div class="d-flex align-items-center gap-3">
														<input type="radio" id="store-product" name="business-type" class="custom-radio" name="add-storeItem" (click)="onBusinessTypeChange.emit('product')" [checked]="myStoreType == 'product'">
														<label class="m-0" for="store-product" i18n="@@common.product">Product</label>
													</div>
													<div class="d-flex align-items-center gap-3">
														<input type="radio" id="store-service" name="business-type" class="custom-radio" name="add-storeItem" (click)="onBusinessTypeChange.emit('service')" [attr.checked]="myStoreType == 'service' ? true : false">
														<label class="m-0" for="store-service" i18n="@@common.service">Service</label>
													</div>
												</div>
											</div>
										</div>

										<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
											<div class="status_wrap w-50 w-none-100 store-information--box">
												<fieldset class="add-categories pb-4">
													<label>
														<ng-container i18n="@@store.add_categories">Add Categories</ng-container>
													</label>
													<select class="categories select2-hidden-accessible"
                            app-select2-multiple
                            [options]="{ ajax: {
                              url: serviceCategoriesApi },
                              idColumn: 'name',
                              textColumn: 'name',
                              tags: true
                            }"
                            (onUnselect)="onUnselectServiceCategory($event)"
                            [selected]="selectedServiceCategories ? selectedServiceCategories : null"
                            i18n-data-placeholder="@@store.add_service_categories"
                            data-placeholder="Add Service Categories" formControlName="service_categories" multiple="multiple">
                          </select>
                          <span class="field-error" *ngIf="(isSubmitted || f.service_categories.dirty) && f.service_categories.errors?.required">Add at least one category</span>
                          <span class="field-error" *ngIf="f.service_categories.errors?.serverError">{{ f.service_categories.errors?.serverError }}</span>
												</fieldset>
											</div>

											<div class="w-50 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.slug.dirty) && f.slug?.errors }">
													<label class="catalogue-details__labelTip" i18n="@@store.catalogue_link_name">Catalogue Link Name <span>(Useful for sending shop URLs to customers)</span></label>
													<div class="catalogue-details__copyField">
														<input type="text" name="catalogue_link" #slug formControlName="slug" (keyup)="convertToSlug(slug.value)" (blur)="convertToSlug(slug.value)" />
														<span class="copy" i18n="@@store.copy" (click)="copyText()">Copy</span>
													</div>
													<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.required">Required</span>
													<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.slug.dirty) && f.slug.errors?.slugTaken">Slug is already taken</span>
													<span class="field-error" *ngIf="f.slug.errors?.serverError">{{ f.slug.errors?.serverError }}</span>
													<span class="catalogue-details__businessUrl" >{{ storeUrl }}</span>
												</fieldset>
											</div>
										</div>

										<div class="w-100">
											<div class="input-group">
												<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.description.dirty) && f.description?.errors }">
													<label i18n="@@business_description">Business Description</label>
													<textarea name="description" rows="5" formControlName="description"></textarea>
													<span *ngIf="(isSubmitted || f.description.dirty) && f.description.errors?.required" i18n="@@error.required.description" class="field-error">Description is required</span>
												</fieldset>
											</div>
										</div>

										<div class="d-flex justify-content-between align-items-center gap-4 flex-none-column align-items-none-start">
											<div class="w-50 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.phone.dirty) && f.phone?.errors }">
													<label i18n="@@store.phone_number">Phone Number</label>
													<input type="number" name="phone" formControlName="phone" maxlength="15" />
													<span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.required">Phone number is required </span>
													<span class="field-error" i18n="@@error.phone_number_only" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.pattern">Please enter number only </span>
													<span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.phone.dirty) && (f.phone.errors?.minlength || f.phone.errors?.maxlength)">The phone number must be less than 5 and 30 digits</span>
													<span class="field-error" *ngIf="f.phone.errors?.serverError">{{ f.phone.errors?.serverError }}</span>
												</fieldset>
											</div>

											<div class="w-50 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone?.errors }">
													<label  i18n="@@store.whatsapp_business_number">Whatsapp Business Number</label>
													<div class="catalogue-details__whatsappNumber">
														<label class="whatsapp-number" for="whatsapp-number">https://wa.me/+{{ basicInfo?.calling_code }}</label>
														<input type="number" placeholder="+966 123 456 789" id="whatsapp-number" name="store-name" formControlName="whatsapp_phone"/>
														<span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.required">Whatsapp number is required </span>
														<span class="field-error" i18n="@@error.whatsapp_phone_number_only" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && f.whatsapp_phone.errors?.pattern">Please enter number only </span>
														<span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.whatsapp_phone.dirty) && (f.whatsapp_phone.errors?.minlength || f.whatsapp_phone.errors?.maxlength)">The Whatsapp number must be less than 5 and 30 digits</span>
														<span class="field-error" *ngIf="f.whatsapp_phone.errors?.serverError">{{ f.whatsapp_phone.errors?.serverError }}</span>
													</div>
												</fieldset>
											</div>
										</div>
									</div>

									<div class="user_info_container gap-3">
										<div class="d-flex align-items-center gap-2 mb-2">
											<div class="custom-checkbox">
												<input class="select-item orders_inputAll" id="checkbox-001" type="checkbox" formControlName="upload_reference_files">
												<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
												</svg>
												<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
													<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</div>
											<label for="checkbox-001" i18n="@@allow_customers_to_upload_reference_files">
												Allow customers to upload reference files
											</label>
										</div>

										<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
											<div class="d-flex gap-2 align-items-center">
												<div class="custom-checkbox show_mandatory">
													<input tm-toggle="additional-information" class="select-item orders_inputAll" id="checkbox-002" type="checkbox" formControlName="allow_additional_info" >
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<label for="checkbox-002" i18n="@@allow_customers_to_add_additional_info">
													Allow customer to add additional info
												</label>
											</div>
											<!-- <span class="help_tooltip" i18n="@@how_does_this_work">How does this work?</span> -->
										</div>


										<!-- <div class="user_info_container gap-3" [class.d-none]="!f.allow_additional_info.value">
											<ng-container formArrayName="additional_info">
												<ng-container *ngFor="let item of additionalInfo.controls; let i=index" [formGroupName]="i">
													<div class="align-items-center gap-4 flex-none-column align-items-none-start mandatory_field" >
														<div class="w-50 position-relative w-none-98">
															<div class="input-group">
																<fieldset class="no-label mb-0"  [ngClass]="{ 'has-error': isSubmitted && getInformationFormGroup(i).get('information')?.invalid }">
																	<textarea name="description" i18n-placeholder="@@setting.additional_info" placeholder="Additional information" formControlName="information" maxlength="78"></textarea>
																	<span  class="field-error" i18n="@@error.required" *ngIf="isSubmitted && getInformationFormGroup(i).get('information')?.errors?.required">* Required</span>
																</fieldset>
															</div>
															<div class="d-flex justify-content-between pt-2">
																<div class="d-flex align-items-center gap-3">
																	<div class="custom-checkbox">
																		<input class="select-item orders_inputAll" id="index-{{i}}" type="checkbox" formControlName="make_mandatory" (click)="makeMandatory(i, $event)">
																		<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																			<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
																		</svg>
																		<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
																			<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																		</svg>
																	</div>
																	<label for="index-{{i}}" i18n="@@make_mandatory">Make mandatory</label>
																</div>
															</div>
															<svg class="close_icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" *ngIf="i != 0" (click)="deleteAdditionalInfo(i)">
																<path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>
														<div class="w-50 d-flex align-items-center gap-2 pl-4 w-none-100 pl-none-0">
														</div>
													</div>
												</ng-container>
											</ng-container>

											<button type="button" id="add_field" class="add_field mt-4" (click)="addAdditionalInfo()">
												<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
													<path d="M10.0001 4.16666V15.8333M4.16675 9.99999H15.8334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
												<ng-container i18n="@@add_another">Add field</ng-container>
											</button>
										</div> -->

										<div class="d-flex align-items-center gap-2 flex-none-column align-items-none-start">
											<div class="d-flex gap-2 align-items-center">
												<div class="custom-checkbox show_comments">
													<input tm-toggle="shop-comments" class="select-item orders_inputAll" id="checkbox-005" type="checkbox" formControlName="allow_shop_comment" (click)="allowShopComments($event)">
													<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
													</svg>
													<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
														<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
														<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
												<label for="checkbox-005" i18n="@@add_shop_comments">Add Shop comments </label>
											</div>
											<span class="help_tooltip" i18n="@@how_does_this_work">How does this work?</span>
										</div>

										<div id="shop-comments" class="align-items-center gap-4 mb-2 flex-none-column align-items-none-start comments_field" [class.d-none]="!f.allow_shop_comment.value">
											<div class="w-50 position-relative w-none-98">
												<div class="input-group">
													<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.shop_comments.dirty) && f.shop_comments?.errors }">
														<label i18n="@@shop_comments">Shop Comment</label>
														<textarea placeholder="e.g Please note any orders placed past 5pm will be rejected" formControlName="shop_comments" ></textarea>
														<span *ngIf="(isSubmitted || f.shop_comments.dirty) && f.shop_comments.errors?.required" i18n="@@error.required" class="field-error">Shop Comment is required</span>
													</fieldset>
												</div>
											</div>
										</div>

										<div class="d-flex align-items-center gap-2 mb-2">
											<div class="custom-checkbox">
												<input class="select-item orders_inputAll" id="checkbox-007" type="checkbox" formControlName="accept_inside_ksa">
												<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
												</svg>
												<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
													<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</div>
											<label for="checkbox-007" i18n="@@accept_requests_from_inside_city">Accept requests from inside your city within KSA</label>
										</div>

                    					<div class="d-flex align-items-center gap-2 mb-2">
											<div class="custom-checkbox">
												<input class="select-item orders_inputAll" id="checkbox-006" type="checkbox" formControlName="accept_outside_ksa">
												<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
												</svg>
												<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
													<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</div>
											<label for="checkbox-006" i18n="@@accept_requests_from_outside_city">Accept requests from outside your city within KSA</label>
										</div>
									</div>

									<div class="user_info_container gap-3">
										<div class="w-100">
											<div class="input-group">
												<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.terms_conditions.dirty) && f.terms_conditions?.errors }">
													<div class="d-flex gap-2 align-items-start pointer">
														<label>
															<ng-container i18n="@@store.business_terms_conditions">Terms and conditions</ng-container>															
														</label>
														<div class="tooltip_wrapper">
															<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
																<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
															<div class="help_tooltip_text">
																<ng-container i18n="@@store.business_terms_and_conditions_tooltip">
																	Add a Terms and conditions of your business. This will appear in your store.
																</ng-container>
																<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																	<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																</svg>
															</div>
														</div>
													</div>														
													<textarea name="terms_conditions" rows="5" formControlName="terms_conditions"></textarea>
													<span *ngIf="(isSubmitted || f.terms_conditions.dirty) && f.terms_conditions.errors?.required" i18n="@@error.required.terms_conditions" class="field-error">Terms and conditions is required</span>
												</fieldset>
											</div>
										</div>
									</div>

									<div class="user_info_container gap-3">
										<div class="w-100">
											<div class="input-group">
												<fieldset class="" [ngClass]="{ 'has-error':( isSubmitted || f.privacy_policy.dirty) && f.privacy_policy?.errors }">
													<div class="d-flex gap-2 align-items-start pointer">
														<label>
															<ng-container i18n="@@store.business_privacy_policy">Privacy and policy</ng-container>															
														</label>
														<div class="tooltip_wrapper">
															<svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 18 27" fill="none">
																<path d="M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M9 12.5V9.5M9 6.5H9.0075" stroke="#1C6AB6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
															<div class="help_tooltip_text">
																<ng-container i18n="@@store.business_privacy_policy_tooltip">
																	Add a Privacy and policy of your business. This will appear in your store.
																</ng-container>
																<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
																	<path d="M6.76795 1C7.53775 -0.333332 9.46225 -0.333334 10.2321 1L16.7272 12.25C17.497 13.5833 16.5348 15.25 14.9952 15.25H2.00481C0.46521 15.25 -0.497042 13.5833 0.272758 12.25L6.76795 1Z" fill="#EDEDED"/>
																</svg>
															</div>
														</div>
													</div>														
													<textarea name="privacy_policy" rows="5" formControlName="privacy_policy"></textarea>
													<span *ngIf="(isSubmitted || f.privacy_policy.dirty) && f.privacy_policy.errors?.required" i18n="@@error.required.privacy_policy" class="field-error">Privacy and policy is required</span>
												</fieldset>
											</div>
										</div>
									</div>

									<div class="d-flex w-100 align-items-center justify-content-end mt-4">
										<button type="button" class="add_field continue" (click)="tabChange('store-address')">
											Continue
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</button>
									</div>
								</div>
							</div>

							<div class="tab-pane fade" [class.show]="activeTab == 'store-address'" [class.active]="activeTab == 'store-address'" id="store-address-content" role="tabpanel" aria-labelledby="pills-new-tab">
								<div id="my-store_info" style="width: 100%">


									<div class="user_info_container gap-4 d-flex justify-content-between align-items-center flex-row flex-none-column align-items-none-start">
										<div class="w-50 service_hide  w-none-100">
											<fieldset>
												<label> <ng-container i18n="@@google_pin_drop_location">Google pin drop location </ng-container> <a class="city-link" href="javascript:void(0)" (click)="openGoogleMap()" i18n="@@open_map"> open map</a></label>
												<input type="text" name="drop-location" formControlName="address" readonly>
											</fieldset>
										</div>
										<div class="w-50 service_hide"></div>
									</div>

									<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
										<div class="d-flex flex-column w-50 gap-3 w-none-100">
											<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.country_id.dirty) && f.country_id?.errors }">
												<label i18n="@@store.country">Country</label>
												<select
                          app-select2
                          [options]="{
                            ajax: {url: countryListApi},
                            idColumn: 'id',
                            textColumn: 'name'
                          }" (itemSelected)="onChangeCountry($event)" [selected]="selectedCountry ? {id: selectedCountry.id, text: selectedCountry.country_name} : null" i18n-placeholder="@@business.country_placeholder" placeholder="Please type country name" name="country_id" formControlName="country_id">
                        <option></option>
                        </select>
                        <span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.country_id.dirty) && f.country_id.errors?.required">Required</span>
                        <span class="field-error" *ngIf="f.country_id.errors?.serverError">{{ f.country_id.errors?.serverError }}</span>
											</fieldset>
										</div>

										<ng-container *ngIf="outsideSA; else insideSA">
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.city_name.dirty) && f.city_name?.errors }">
													<label i18n="@@store.city">City</label>
													<input type="text" name="city" formControlName="city_name" >
													<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.city_name.dirty) && f.city_name.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.city_name.errors?.serverError">{{ f.city_name.errors?.serverError }}</span>
												</fieldset>
											</div>
										</ng-container>
										<ng-template #insideSA>
											<div class="d-flex flex-column w-50 gap-3 w-none-100">
												<fieldset class="" [ngClass]="{ 'has-error': (isSubmitted || f.city_id.dirty) && f.city_id?.errors }">
													<label i18n="@@store.city">City</label>
													<select app-select2 [options]="{
                              data: cities ? cities : [],
                              idColumn: 'id',
                              textColumn: 'name'
                            }" [selected]="selectedCity ? {id: selectedCity.id, text: selectedCity.name}  : {}" i18n-placeholder="@@store.please_select" placeholder="Select City" data-placeholder="Select City" name="city_id" formControlName="city_id">
                            <option></option>
                          </select>
													<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.city_id.dirty) && f.city_id.errors?.required">Required</span>
													<span class="field-error" *ngIf="f.city_id.errors?.serverError">{{ f.city_id.errors?.serverError }}</span>
												</fieldset>
											</div>
										</ng-template>
									</div>


									<div class="d-flex w-100 align-items-center justify-content-end mt-4">
										<a href="javascript:void(0)" class="tu-btn blue update" form="ngForm" (click)="informationForm.ngSubmit.emit()" i18n="@@submit_catlogue_details">Submit catlogue details</a>
									</div>

								</div>
							</div>


							</form>
						</div>
					</div>
				</div>
			</section>
		</div>





  </div>
</section>
